<!-- Navbar -->
<div class="fixed mt-2 w-100" style="z-index: 300;" *ngIf="visible">
  <nav class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
    id="layout-navbar">
    <!-- ==========  MOBILE VERSION ====================  -->
    <div *ngIf="isMobile" class="mobile-navbar">
      <button type="button" class="btn-mobile-menu" (click)="toggleMobileMenu()">
        <i class="pi" [ngClass]="mobileMenuOpen ? 'pi-times' : 'pi-bars'"></i>
      </button>
    
      <div *ngIf="mobileMenuOpen" class="mobile-menu">
    
        <!-- * Noticias -->
        <button *ngIf="images.length" type="button" class="mobile-menu-item" (click)="visibleNews = true">
          <div class="mobile-menu-item-content">
            <i class="pi pi-images"></i>
            <span>Noticias</span>
          </div>
          <span class="news-badge">{{ images.length }}</span>
        </button>
    
        <!-- * Agenda -->
        <div class="mobile-menu-item-wrapper">
          <button type="button" class="mobile-menu-item" (click)="toggleOverlay('agenda')">
            <div class="mobile-menu-item-content">
              <fa-icon [icon]="['far', 'calendar']"></fa-icon>
              <span>Agenda</span>
            </div>
          </button>
          <div class="mobile-dropdown" *ngIf="activeOverlay === 'agenda'">
            <div class="agenda-widget" style="padding: 10px;">
              <h4 class="agenda-title">Agenda semanal</h4>
              <p class="agenda-link" routerLink="agenda">Ver agenda completa</p>
              <div class="agenda-scroll">
                <div class="item-notification">
                  <ng-container *ngFor="let a of agenda; let i = index">
                    <div class="top-container" (click)="item.hide = !item.hide">
                      <h4>
                        {{ dias[i] }}
                        {{ addDays(obtenerFechasLunesADomingo().lunes, i).getDate() }}
                        {{ today === i ? '(hoy)' : '' }}
                      </h4>
                      <i class="pi pi-angle-down"></i>
                    </div>
                    <app-item-agenda #item [item]="a.evento"></app-item-agenda>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- * Mensajes -->
        <div class="mobile-menu-item-wrapper">
          <button type="button" class="mobile-menu-item" (click)="toggleOverlay('mensajes')">
            <div class="mobile-menu-item-content">
              <fa-icon [icon]="['far', 'envelope']"></fa-icon>
              <span>Mensajes</span>
            </div>
            <div class="circle pulse orange" *ngIf="activeOverlay === 'mensajes'"></div>
          </button>
          <app-nav-button #navButton [name]="'mensajes'" [icon]="['far', 'envelope']" [hasMenu]="true" [mobile]="true"
            [hideButton]="true" [mobileOpen]="activeOverlay === 'mensajes'" />
        </div>
    
        <!-- * Goal Zero -->
        <div class="mobile-menu-item-wrapper">
          <button type="button" class="mobile-menu-item" (click)="toggleOverlay('goal')">
            <div class="mobile-menu-item-content">
              <span>Goal Zero</span>
            </div>
          </button>
          <div class="mobile-dropdown" *ngIf="activeOverlay === 'goal'">
            <div class="goal-card-container position-relative" style="padding: 10px;">
              <app-goal-card [title]="'GOAL ZERO'" [date1]="goals[0] ? goals[0].init_date : undefined"
                [description1]="goals[0] ? goals[0].description : undefined" [id1]="1"
                [date2]="goals[1] ? goals[1].init_date : undefined"
                [description2]="goals[1] ? goals[1].description : undefined" [id2]="2"
                (buttonClick)="insertGoal($event)"></app-goal-card>
            </div>
          </div>
        </div>
    
        <!-- * Vaca Muerta -->
        <div class="mobile-menu-item-wrapper">
          <button type="button" class="mobile-menu-item" (click)="toggleOverlay('vaca')">
            <div class="mobile-menu-item-content">
              <span>Vaca Muerta</span>
            </div>
          </button>
          <div class="mobile-dropdown" *ngIf="activeOverlay === 'vaca'">
            <div class="goal-card-container position-relative" style="padding: 10px;">
              <app-goal-card [title]="'VACA MUERTA ZERO DAY'" [date1]="goals[2] ? goals[2].init_date : undefined"
                [description1]="goals[2] ? goals[2].description : undefined"
                [date2]="goals[3] ? goals[3].init_date : undefined"
                [description2]="goals[3] ? goals[3].description : undefined" [id1]="3" [id2]="4"
                (buttonClick)="insertGoal($event)"></app-goal-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ DESKTOP =================  -->
    <div *ngIf="!isMobile" id="nav-buttons" class="container-fluid justify-content-start">
      <!-- *Noticias -->
      <button class="btn-news" (click)="visibleNews = true" *ngIf="images.length">
        <i class="pi pi-images"></i>
        <span class="news-badge">
          {{ images.length }}
        </span>
      </button>

      <!-- * Agenda -->
      <app-nav-button [name]="'calendar'" [icon]="['far', 'calendar']" (mouseover)="show = true"
        (mouseleave)="show = false" />
      <div class="absolute hide-container shadow-2"
        style="top: 100%; border-radius: 10px; background: white; max-height: 60vh;"
        [ngClass]="{ 'show-container': show }" (mouseover)="show = true" (mouseleave)="show = false">
        <div style="max-width: 500px">
          <div class="agenda-widget">

            <h4 class="agenda-title">Agenda semanal</h4>
            <p class="agenda-link" routerLink="agenda">
              Ver agenda completa
            </p>
            <div class="agenda-scroll">
              <div class="item-notification">
                <ng-container *ngFor="let a of agenda; let i = index">
                  <div class="top-container" (click)="item.hide = !item.hide">
                    <h4>
                      {{ dias[i] }}
                      {{ addDays(obtenerFechasLunesADomingo().lunes, i).getDate() }}
                      {{ today === i ? '(hoy)' : '' }}
                    </h4>
                    <i class="pi pi-angle-down"></i>
                  </div>
                  <app-item-agenda #item [item]="a.evento">
                  </app-item-agenda>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- * Mensajes -->
      <app-nav-button [name]="'calendar'" [icon]="['far', 'envelope']" [hasMenu]="true" />

      <!-- * Goal Zero -->
      <button type="button" class="btn-goal-zero" (mouseover)="showGoal = true" (mouseleave)="showGoal = false">
        Goal Zero
      </button>
      <div class="absolute hide-container shadow-2"
        style="top: 100%; border-radius: 10px; background: white; max-height: 60vh;"
        [ngClass]="{ 'show-container': showGoal }" (mouseover)="showGoal = true" (mouseleave)="showGoal = false">
        <div style="max-width: 500px; overflow: scroll">
          <div style="padding: 10px; max-width: 500px;">
            <div class="goal-card-container position-relative">

              <app-goal-card [title]="'GOAL ZERO'" [date1]="goals[0] ? goals[0].init_date : undefined"
                [description1]="goals[0] ? goals[0].description : undefined" [id1]="1"
                [date2]="goals[1] ? goals[1].init_date : undefined"
                [description2]="goals[1] ? goals[1].description : undefined" [id2]="2"
                (buttonClick)="insertGoal($event)"></app-goal-card>
            </div>
            <!-- <div style="padding: 2px 10px 2px 10px; cursor: pointer; position: relative" class="item-notification">

              <ng-container *ngFor="let a of agenda; let i = index">
                <div class="top-container" (click)="item.hide = !item.hide">
                  <h4 class="m-0">{{ dias[i] }} {{ addDays(obtenerFechasLunesADomingo().lunes, i).getDate() }}
                    {{ today === i ? '(hoy)' : '' }}</h4>
                  <i class="pi pi-angle-down" style="font-size: 1.2rem"></i>
                </div>
                <app-item-agenda #item [item]="a.evento" />
              </ng-container>

            </div> -->
            <!-- <p class="mt-2 text-center" style="cursor: pointer" routerLink="agenda">Ver agenda completa</p> -->
          </div>
        </div>
      </div>

      <!-- * Vaca Muerta -->
      <button type="button" class="btn-goal-zero" (mouseover)="vacaMuerta = true" (mouseleave)="vacaMuerta = false">
        Vaca Muerta
      </button>
      <div class="absolute hide-container shadow-2"
        style="top: 100%; border-radius: 10px; background: white; max-height: 60vh;"
        [ngClass]="{ 'show-container': vacaMuerta }" (mouseover)="vacaMuerta = true" (mouseleave)="vacaMuerta = false">
        <div style="max-width: 500px; overflow: scroll">
          <div style="padding: 10px; max-width: 500px; ">
            <div class="goal-card-container position-relative">
              <app-goal-card [title]="'VACA MUERTA ZERO DAY'" [date1]="goals[2] ? goals[2].init_date : undefined"
                [description1]="goals[2] ? goals[2].description : undefined"
                [date2]="goals[3] ? goals[3].init_date : undefined"
                [description2]="goals[3] ? goals[3].description : undefined" [id1]="3" [id2]="4"
                (buttonClick)="insertGoal($event)"></app-goal-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============= END Buttons ============== -->

    <!-- ================ USER y TICKETS ========================= -->
    <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
      <ul class="navbar-nav flex-row align-items-center ms-auto">
        <!-- * Tickets -->
        <div style="display:flex">
          <app-nav-button [name]="'Tickets'" [icon]="['fas', 'ticket']" [pTooltip]="'Tickets'"
            [tooltipPosition]="'left'" [routerLink]="'ticket-gen'" />
          <div class="circle pulse orange" style="margin-left: -20px;margin-top: 10px;" *ngIf="hasNotification"></div>
        </div>

        <!-- * User -->
        <app-nav-user />
      </ul>
    </div>
  </nav>


  <!-- ============== overlays (desktop) ================= -->
  <div class="news-overlay" *ngIf="visibleNews && images.length">
    <button class="close-news" (click)="closeNews()">
      <i class="pi pi-times"></i>
    </button>
    <div class="news-content">
      <p-carousel [value]="images" [numVisible]="1" [numScroll]="1" [circular]="true" [autoplayInterval]="5000">
        <ng-template let-image pTemplate="item">
          <div class="news-item">
            <img [src]="image.imagen" class="news-image" />
            <h3>{{ image.description }}</h3>
            <button *permission="['admin']" class="add-news-inline" (click)="visibleUpload  = true;visibleNews = false">
              <i class="pi pi-plus"></i>
              Agregar novedad
            </button>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>
<p-dialog [modal]="true" [style]="{ width: '85vw', height: '90vh' }" [draggable]="false" [resizable]="false"
  [position]="'top'" [(visible)]="visibleUpload" (onHide)="hideDialog()">
  <ng-template pTemplate="header"></ng-template>
  <div [style]="{ width: '100%', height: '100%' }" class="relative">
    <div *ngIf="!imageToEdit" class="custom-center contenedor" (click)="fileInput.click()">
      <i class="pi pi-upload text-secondary"></i>
      <h2 class="text-secondary mt-3">Cargar imagen</h2>
      <input hidden type="file" accept="image/png, image/gif, image/jpeg, image/jpg" #fileInput
        (change)="addImage($event, fileInput)" />
    </div>

    <image-cropper [imageBase64]="imageToEdit" [transform]="transform" (imageCropped)="imageCropped($event)"
      [canvasRotation]="canvasRotation" [aspectRatio]="5 / 3" [maintainAspectRatio]="true"></image-cropper>
    <div *ngIf="imageToEdit" pRipple class="float-button-img left shadow-2 custom-center" (click)="rotateLeft()">
      <i class="pi pi-replay"></i>
    </div>

    <div *ngIf="imageToEdit" pRipple class="float-button-img right shadow-2 custom-center" (click)="rotateRight()">
      <i class="pi pi-refresh"></i>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="row" *ngIf="imageToEdit">
      <div class="col-12">
        <textarea pInputTextarea [style]="{ width: '100%' }" [(ngModel)]="description" name="description"
          id="description" rows="3"></textarea>
      </div>
      <div class="col-12 text-end">
        <ng-container *ngIf="!edit; else editImage">
          <button class="btn btn-primary" (click)="onInsertImage(dialog)">
            Subir imagen
          </button>
        </ng-container>
        <ng-template #editImage>
          <button class="btn btn-primary" (click)="onEditImage(dialog)">
            Editar imagen
          </button>
          <button class="btn btn-danger ml-3" (click)="onDeleteImage(dialog)">
            Borrar imagen
          </button>
        </ng-template>
      </div>
    </div>
  </ng-template>
</p-dialog>
<!-- / Navbar -->
<app-dialog #dialog />